<template>
  <div :class="'messageItem ' + (message.is_sender ? 'messageItem__right' : 'messageItem__left') + (message.system ? '' : '--background')">
    <blockquote
      v-if="message.system"
      class="messageItem__action"
    >
      <div class="messageItem__action--title">
        {{message.action}}
      </div>
      <div>{{message.content}}</div>
      <div class="messageItem__time">
        {{$moment(message.created_at).calendar()}}
        <md-icon
          v-if="message.is_sender ? !!message.user_read_at : !!message.customer_read_at"
          name="check_circle"
        />
      </div>
    </blockquote>
    <div v-else>
      <div class="messageItem__author">
        <md-icon
          v-if="!message.is_sender"
          name="contact_mail"
        />
        <!--span
          v-else
          class="messageItem__author--code"
        >{{code}}</span-->
        <span>{{message.sender}}</span>
      </div>
      <div class="messageItem__content">{{message.content}}</div>
      <div class="messageItem__time">
        {{$moment(message.created_at).calendar()}}
        <md-icon
          v-if="message.is_sender ? !!message.user_read_at : !!message.customer_read_at"
          name="check_circle"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageItem",
  props: {
    message: {
      type: Object,
      default: null
    }
  },
  /*computed: {
    code() {
      return this.message.sender.split(' ').reduce((p, n) => p + n.substring(0, 1), '')
    }
  },*/
  async mounted() {
    if (!this.message.customer_read_at) {
      try {
        await this.$store.dispatch("records/updateMessage", {
          recordId: this.$route.params.id,
          messageId: this.message.id,
          message: {
            customer_read_at: new Date()
          }
        })
      } catch (error) {
        console.warn(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.messageItem';

#{$c} {
  width: 60%;
  margin-bottom: 8px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  &__left--background {
    background-color: $--background-color-silver;
    padding: 16px;
  }

  &__left &__action {
    border-left: 2px black solid;
    padding-left: 10px;
  }

  &__right {
    align-self: flex-end;
  }

  &__right--background {
    align-self: flex-end;
    background-color: $--background-color-black;
    color: $--color-white;
    padding: 16px;
  }

  &__right &__time,
  &__right--background &__time,
  &__right &__action,
  &__right--background &__action {
    align-self: flex-end;
    font-size: $--font-size-medium;
    text-align: right;
  }
  &__right &__action {
    border-right: 2px black solid;
  }

  &__time {
    color: $--color-info;

    i {
      color: $--color-success;
      font-size: 16px;
      vertical-align: middle;
      margin-left: 8px;
    }
  }

  &__content {
    line-height: 18px;
    margin-bottom: 11px;
    word-break: break-all;
  }

  &__author {
    margin-bottom: 20px;
    margin-top: 10px;

    i {
      line-height: 17px;
      margin-right: 8px;
      vertical-align: middle;
    }

    &--code {
      background-color: #424950;
      border-radius: 50%;
      padding: 11px 14px;
      margin-right: 8px;
      margin-bottom: 8px;
      min-width: 20px;
    }
  }

  &__action {
    line-height: 30px;
    margin: 0;
    padding-right: 10px;

    &--title {
      font-style: italic;
    }
  }
}
</style>